<!-- src/pages/exam/Apply.vue -->
<template>
  <main class="exam-apply">
    <!-- 진행 단계 -->
    <div class="steps" aria-label="접수 단계">
      <div class="step is-active">
        <span class="step__num" aria-hidden="true">01</span>
        <span class="step__label">기본정보</span>
      </div>
      <span class="step__arrow" aria-hidden="true">></span>
      <div class="step">
        <span class="step__num" aria-hidden="true">02</span>
        <span class="step__label">접수완료</span>
      </div>
    </div>

    <!-- 폼 -->
    <!-- <form class="apply-form" @submit.prevent="goUpdate"> -->
    <form class="apply-form" @submit.prevent>

      <table class="apply-table" role="table" aria-label="시험 접수 기본정보">
        <colgroup>
          <col style="width: 220px" />
          <col />
        </colgroup>

        <tbody>
          <tr>
            <th scope="row">* 시험구분</th>
            <td class="inline">
              <label class="ck">
                <input type="radio" name="examType" value="CICS" v-model="state.requestedCert" /> CICS
              </label>
              <label class="ck">
                <input type="radio" name="examType" value="CICP" v-model="state.requestedCert" /> CICP
              </label>
            </td>
          </tr>
          <tr>
            <th scope="row">* 성명(국문)</th>
            <td><input type="text" class="inp" placeholder="이름을 입력하세요" v-model="state.nameKr" /></td>
          </tr>
          <tr>
            <th scope="row">* 성별</th>
            <td class="inline">
              <label class="ck">
                <input type="radio" name="gender" value="M" v-model="state.gender" /> 남
              </label>
              <label class="ck">
                <input type="radio" name="gender" value="F" v-model="state.gender" /> 여
              </label>
            </td>
          </tr>
          <tr>
            <th scope="row">* 성명_성(영문)</th>
            <td><input type="text" class="inp" placeholder="&#8251;영문 성은 반드시 여권상의 이름과 동일해야 합니다."
                v-model="state.engFirstName" /></td>
          </tr>
          <tr>
            <th scope="row">* 성명_이름(영문)</th>
            <td><input type="text" class="inp" placeholder="&#8251;영문 이름은 반드시 여권상의 이름과 동일해야 합니다."
                v-model="state.engLastName" /></td>
          </tr>
          <tr>
            <th scope="row">* 생년월일</th>
            <td><input type="date" class="inp" v-model="state.birthDate" /></td>
          </tr>
          <tr>
            <th scope="row">* 회사명(국문)</th>
            <td><input type="text" class="inp" placeholder="회사명을 입력하세요" v-model="state.companyNameKr" /></td>
          </tr>
          <tr>
            <th scope="row">* 직급(국문)</th>
            <td><input type="text" class="inp" placeholder="직급을 입력하세요" v-model="state.positionKr" /></td>
          </tr>
          <tr>
            <th scope="row">회사연락처</th>
            <td><input type="tel" class="inp" placeholder="02-0000-0000" v-model="state.companyTel" /></td>
          </tr>
          <tr>
            <th scope="row">* 휴대전화</th>
            <td><input type="tel" class="inp" placeholder="010-0000-0000" v-model="state.mobileTel" /></td>
          </tr>
          <tr>
            <th scope="row">* 이메일</th>
            <td><input type="email" class="inp" placeholder="&#8251;해당 이메일은 시험 진행 사항이 e-mail로 발송되오니 회사 메일은 기입은 지양바랍니다."
                v-model="state.email" /></td>
          </tr>
          <tr>
            <th scope="row">* 내부통제 분야 경력(년)</th>
            <td><input type="number" min="0" class="inp w-160" placeholder="0" v-model="state.experienceYears" /> 년</td>
          </tr>

          <!-- ✅ 취득한 자격증: 체크박스 + 기타 입력 -->
          <tr>
            <th scope="row">취득한 자격증</th>
            <td class="cert-row">
              <label class="ck" v-for="(cert, index) in state.obtainedCerts" :key="index">
                <input type="checkbox" :value="Object.keys(cert)[0]"
                  v-model="state.obtainedCerts[index][Object.keys(cert)[0]]" />
                {{ Object.keys(cert)[0] }}
              </label>

              <span class="etc-wrap">
                <label for="cert-etc" class="etc-label">기타</label>
                <input id="cert-etc" type="text" class="inp etc-inp" placeholder="예: CIA, CMA 등"
                  v-model="state.obtainedCertsEtc" />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="state.requestedCert === 'CICS'">
        <div class="file-guide">
          <div class="file-guide__left">
            <div class="file-guide__text">
              <p class="file-guide__title">경력증명서 양식 다운로드</p>
              <p class="file-guide__desc">
                양식을 다운로드 후 작성하여 아래에 첨부해주세요.
              </p>
            </div>
          </div>

          <a :href="applicationForm" download class="file-guide__btn">
            다운로드
          </a>
        </div>

        <!-- 첨부 영역 -->
        <div class="attach-section">
          <input type="file" ref="fileInput" class="file-hidden" @change="onFileChange" />

          <div class="attach-box" @click="triggerFile" @dragover.prevent @drop.prevent="onDrop">
            <span class="attach-box__text">
              파일 첨부하기
              <em>또는 파일을 드래그하세요</em>
            </span>
          </div>

          <ul class="file-list">
            <li v-if="state.licenseFile && uploadedFiles.length === 0">
              <button
                type="button"
                class="file-name"
                @click="downloadExistingFile(state.licenseFile)"
              >
                {{ state.licenseFile.split('/').pop() }}
              </button>

              <button class="file-name-btn" type="button" @click="removeExistingFile">삭제</button>
            </li>

            <li v-for="(file, idx) in uploadedFiles" :key="file.name">
              <button
                type="button"
                class="file-name"
                @click="downloadUploadedFile(file)"
              >
                {{ file.name }}
              </button>

              <button class="file-name-btn" type="button" @click="removeFile(idx)">삭제</button>
            </li>
          </ul>
        </div>
      </div>

      <div class="actions">
        <button type="button" class="btn btn--ghost" @click="saveDraft">
          임시저장
        </button>

        <button type="button" class="btn btn--primary" @click="finalSubmit">
          접수하기
        </button>
      </div>
    </form>
  </main>
</template>

<script setup>
import { ref, computed, reactive, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { insertLicense, sendApplicant, sendAdmin, draftLicense, updateLicense } from '@/api/license'
import * as Utils from '@/common/util/util'
import axios from 'axios'
const checkUserId = computed(() => store.state.temp.userInfo)
const router = useRouter()
const route = useRoute()
const store = useStore()

const emailError = ref('')
const emailVerifyOpen = ref(false)
const verifyInputRef = ref(null)
const isSending = ref(false)

const applicationForm = '/ici_application_form/ICI Certification Application Form(CICS용).xlsx'

const state = reactive({
  nameKr: checkUserId.value?.userName || '',
  gender: '',
  engLastName: '',
  engFirstName: '',
  birthDate: '',
  companyNameKr: '',
  positionKr: '',
  companyTel: '',
  mobileTel: '',
  email: '',
  experienceYears: '',
  requestedCert: '',
  obtainedCerts: [
    { CCSA: false },
    { CFE: false },
    { CIA: false },
    { CISA: false },
    { CISSP: false },
    { ICCP: false },
  ],
  obtainedCertsEtc: '',
  status: 'SUBMITTED',
  createdByAdminId: '',
  inputFile: '',
  licenseFile: '',
  checkFile: '',
  licenseId: ''
})
const checkField = () => {

  // if (Utils.isEmpty(checkUserId.value.userId)) {
  //   alert("로그인이 필요한 서비스입니다.");
  //   router.push('/login')
  //   return false;
  // }

  if (Utils.isEmpty(state.nameKr)) {
    alert("이름(국문)을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.gender)) {
    alert("성별을 선택해주세요");
    return false;
  }

  if (Utils.isEmpty(state.engLastName) || Utils.isEmpty(state.engFirstName)) {
    alert("영문 이름을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.birthDate)) {
    alert("생년월일을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.companyNameKr)) {
    alert("회사명을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.positionKr)) {
    alert("직위를 입력해주세요");
    return false;
  }

  // if (Utils.isEmpty(state.companyTel)) {
  //   alert("회사 전화번호를 입력해주세요");
  //   return false;
  // }

  if (Utils.isEmpty(state.mobileTel)) {
    alert("휴대전화 번호를 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.email)) {
    alert("이메일을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.experienceYears)) {
    alert("경력을 입력해주세요");
    return false;
  }

  if (Utils.isEmpty(state.requestedCert)) {
    alert("신청 자격증을 선택해주세요");
    return false;
  }

  if (Utils.isEmpty(state.status)) {
    alert("상태값을 입력해주세요");
    return false;
  }

  return true;
};

const goUpdate = async (submitStatus) => {
  if (submitStatus === 'FINAL_SUBMITTED') {
    if (!checkField()) return false
  }

  const confirmMsg = submitStatus === 'SUBMITTED'
    ? '임시저장 하시겠습니까?'
    : '접수 하시겠습니까?'

  if (confirm(confirmMsg)) {
    try {
      const formData = new FormData()

      formData.append('userId', checkUserId.value?.userId || '')
      formData.append('nameKr', state.nameKr)
      formData.append('gender', state.gender)
      formData.append('engLastName', state.engLastName)
      formData.append('engFirstName', state.engFirstName)
      formData.append('birthDate', state.birthDate)
      formData.append('companyNameKr', state.companyNameKr)
      formData.append('positionKr', state.positionKr)
      formData.append('companyTel', state.companyTel)
      formData.append('mobileTel', state.mobileTel)
      formData.append('email', state.email)
      formData.append('experienceYears', state.experienceYears)
      formData.append('requestedCert', state.requestedCert)
      formData.append('obtainedCerts', JSON.stringify(state.obtainedCerts))
      formData.append('obtainedCertsEtc', state.obtainedCertsEtc)
      formData.append('status', submitStatus)
      formData.append('licenseId', state.licenseId)
      formData.append('checkFile', state.checkFile)
      
      if (state.inputFile) { // 파일이 있을때 만
        formData.append('inputFile', state.inputFile)
      }
      
      // const resultVo = await insertLicense(formData)

      let resultVo = null

      if (state.licenseId) {
        resultVo = await updateLicense(formData)
      } else {
        resultVo = await insertLicense(formData)
      }

      if (resultVo?.result === 'ok') {
        if (submitStatus === 'SUBMITTED') {
          alert('임시저장이 완료됐습니다')
          return
        }

        const mailParams = {
          nameKr: state.nameKr,
          gender: state.gender,
          engLastName: state.engLastName,
          engFirstName: state.engFirstName,
          birthDate: state.birthDate,
          companyNameKr: state.companyNameKr,
          positionKr: state.positionKr,
          companyTel: state.companyTel,
          mobileTel: state.mobileTel,
          email: state.email,
          experienceYears: state.experienceYears,
          requestedCert: state.requestedCert,
          obtainedCerts: state.obtainedCerts,
          obtainedCertsEtc: state.obtainedCertsEtc,
          status: submitStatus
        }

        const resultEail = await sendApplicant(mailParams)
        const resultAdminEail = await sendAdmin(mailParams)

        if (resultEail?.result === 'ok' && resultAdminEail?.result === 'ok') {
          alert('시험 접수가 완료됐습니다')
          router.push({ name: 'examregistration2' })
        }
      } else {
        alert(resultVo.resultMsg)
      }
    } catch (error) {
      console.error('저장 중 오류 발생:', error)
    }
  }
}

const fileInput = ref(null)
const uploadedFiles = ref([])

const triggerFile = () => {
  fileInput.value.click()
}

// const onFileChange = (e) => {
//   uploadedFiles.value = [...uploadedFiles.value, ...Array.from(e.target.files)]
// }

const onFileChange = (e) => {
  const file = e.target.files?.[0]
  if (!file) return

  uploadedFiles.value = [file]
  state.inputFile = file
}

const removeFile = (index) => {
  uploadedFiles.value.splice(index, 1)
  state.inputFile = ''
}

const isDragover = ref(false)

const removeExistingFile = () => {
  state.licenseFile = ''
  state.checkFile = ''
}

const onDrop = (e) => {
  const file = e.dataTransfer.files?.[0]
  if (!file) return

  uploadedFiles.value = [file]
  state.inputFile = file
}

function go(to) {
  router.push(to)
}

// const saveDraft = () => {
//   goUpdate('SUBMITTED')
// }

const saveDraft = () => {
  if (Utils.isEmpty(state.gender)) {
    alert('임시저장 전 성별을 선택해주세요')
    return
  }

  goUpdate('SUBMITTED')
}

const finalSubmit = () => {
  goUpdate('FINAL_SUBMITTED')
}

watch(
  () => state.requestedCert,
  (newValue) => {
    if (newValue !== 'CICS') {
      uploadedFiles.value = []
      state.inputFile = ''

      if (fileInput.value) {
        fileInput.value.value = ''
      }
    }
  }
)

const apiBaseUrl = process.env.VUE_APP_API_URL

const fileNameOnly = (path) => {
  return decodeURIComponent(path.split('/').pop() || 'download')
}

const downloadExistingFile = async (filePath) => {
  try {
    const relativePath = filePath.replace(/^https?:\/\/[^/]+/, '')
    const downloadUrl = `${apiBaseUrl}${relativePath}`

    const response = await axios({
      url: downloadUrl,
      method: 'GET',
      responseType: 'blob'
    })

    const blob = new Blob([response.data])
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = fileNameOnly(relativePath)
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('기존 파일 다운로드 실패:', error)
    alert('파일 다운로드 중 문제가 발생했습니다.')
  }
}

const downloadUploadedFile = (file) => {
  if (!file) return

  const url = window.URL.createObjectURL(file)

  const link = document.createElement('a')
  link.href = url
  link.download = file.name
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

onMounted(async () => {
  const userId = checkUserId.value?.userId

  // 로그인 정보 없으면 임시저장 조회 자체를 하지 않음
  if (!userId) {
    console.log('로그인 정보 없음: 임시저장 조회 안 함')
    return
  }

  try {
    const result = await draftLicense({ userId })

    const draft = result?.data

    if (draft && draft.status === 'SUBMITTED') {
      state.nameKr = draft.nameKr || ''
      state.gender = draft.gender || ''
      state.engLastName = draft.engLastName || ''
      state.engFirstName = draft.engFirstName || ''
      state.birthDate = draft.birthDate?.substring(0, 10) || ''
      state.companyNameKr = draft.companyNameKr || ''
      state.positionKr = draft.positionKr || ''
      state.companyTel = draft.companyTel || ''
      state.mobileTel = draft.mobileTel || ''
      state.email = draft.email || ''
      state.experienceYears = draft.experienceYears || ''
      state.requestedCert = draft.requestedCert || ''
      state.obtainedCertsEtc = draft.obtainedCertsEtc || ''
      state.licenseFile = draft.licenseFile || ''
      state.checkFile = draft.licenseFile || ''
      state.licenseId = draft.licenseId || ''


      if (draft.obtainedCerts) {
        state.obtainedCerts = draft.obtainedCerts
      }
    }
  } catch (error) {
    console.error('임시저장 불러오기 실패:', error)
  }
})
</script>

<style scoped>
/* =========================================================
 * 공통 타이포 (요구사항 준수)
 * ======================================================= */
.exam-apply, .exam-apply p, .apply-table th, .apply-table td, .inp, .btn { font-family: 'Noto Sans KR', sans-serif; }
.exam-apply p { font-size: 0.95rem; }

/* 페이지 타이틀(있다면) */
.exam-apply .title, .exam-apply h1 { font-size: 1.625rem; font-weight: 700; }

/* =========================================================
 * 기본 레이아웃 (데스크탑: 테이블 유지)
 * ======================================================= */
.exam-apply { max-width: 820px; margin: 0 auto; padding: 16px 16px 48px; }

/* 단계 표시 */
.steps { display: flex; align-items: center; gap: 10px; margin: 8px 0 20px; color: #555; font-size: 14px; justify-content: center; }
.step { display: inline-flex; align-items: center; gap: 8px; opacity: 0.6; }
.step.is-active { opacity: 1; font-weight: 600; }
.step__num { display: inline-flex; width: 28px; height: 28px; border-radius: 50%; border: 1px solid #ddd; align-items: center; justify-content: center; font-size: 12px; }
.step__arrow { opacity: .4; }

/* 테이블 폼 (데스크탑) */
.apply-table { width: 100%; border: 1px solid #ddd; border-bottom: none; background: #fff; }
.apply-table th, .apply-table td { border-bottom: 1px solid #ddd; padding: 14px 16px; vertical-align: middle; }
.apply-table th { background: #fafafa; text-align: left; font-weight: 600; color: #222; }

/* 입력 공통 */
.inp { width: 100%; max-width: 520px; height: 40px; padding: 0 12px; border: 1px solid #d7d7d7; border-radius: 4px; outline: none; }
.inp:focus { border-color: #8aa1b2; box-shadow: 0 0 0 3px rgba(58, 124, 165, .12); }
.w-160 { width: 160px; }
.inline { display: flex; gap: 16px; align-items: center; flex-wrap: wrap; }
.ck { display: inline-flex; align-items: center; gap: 6px; margin-right: 12px; white-space: nowrap; }
.cert-row { display: flex; flex-wrap: wrap; gap: 10px 18px; align-items: center; }
.etc-wrap { display: inline-flex; align-items: center; gap: 8px; margin-left: 8px; }
.etc-label { color: #333; }
.etc-inp { width: 240px; }

/* 버튼 */
.actions { display: flex; justify-content: center; gap: 12px; margin-top: 24px; }
.btn { min-width: 200px; height: 44px; padding: 0 18px; border-radius: 6px; font-weight: 600; border: 1px solid transparent; }
.btn--ghost { background: #1f2937; color: #fff; cursor: pointer; }
.btn--primary { background: #2b3a67; color: #fff; cursor: pointer; }
.btn:focus-visible { outline: 2px solid #9fb7c7; outline-offset: 2px; }
.muted { color: #6b7280; }
.file-guide { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; border: 1px solid #e5e7eb; border-radius: 8px; background: #f9fafb; margin-top: 12px; }
.file-guide__left { display: flex; align-items: center; gap: 12px; }
.file-guide__icon { font-size: 20px; }
.file-guide__title { font-weight: 600; margin: 0; color: #111827; }
.file-guide__desc { margin: 2px 0 0; font-size: 13px; color: #6b7280; }
.file-guide__btn { padding: 8px 14px; border-radius: 6px; background: #374151; color: #fff; font-size: 13px; text-decoration: none; white-space: nowrap; }
.file-guide__btn:hover { background: #1f2937; }
.file-download-link { display: inline-flex; align-items: center; margin-top: 12px; color: #1f2937; text-decoration: none; font-weight: 500; line-height: 1.4; background: #dfdfdf; }
.file-download-link:hover { text-decoration: underline; color: #111827; }
.file-download-link:focus-visible { outline: 2px solid #9fb7c7; outline-offset: 3px; border-radius: 4px; }
.file-download-link__icon { font-size: 1rem; flex-shrink: 0; }
.file-download-link__text { word-break: break-all; }
.attach-section { margin-top: 16px; }
.file-hidden { display: none; }
.attach-box { display: flex; align-items: center; gap: 10px; margin-top: 12px; padding: 14px 16px; border: 1px dashed #d1d5db; border-radius: 8px; background: #fafafa; cursor: pointer; transition: all 0.15s ease; }
.attach-box:hover { background: #f3f4f6; border-color: #9ca3af; }
.attach-box__icon { font-size: 18px; }
.attach-box__text { font-size: 14px; color: #374151; }
.attach-box__text em { font-style: normal; color: #9ca3af; margin-left: 6px; font-size: 13px; }
.file-list li { display: flex; justify-content: space-between; align-items: center; background: #f9fafb; border: 1px solid #e5e7eb; padding: 8px 10px; border-radius: 6px; margin-top: 6px; font-size: 14px; }
/* .file-name-btn { font-size: 13px; color: #ff0000; } */
.file-name-btn {
  font-size: 12px;
  color: #ef4444;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
}

.file-name-btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

.file-name-btn:focus-visible {
  outline: 2px solid #fca5a5;
  outline-offset: 2px;
}

/* =========================================================
 * 반응형 (모바일: ≤ 720px) — 카드형 Grid 레이아웃
 * ======================================================= */
@media (max-width: 720px) {
  .apply-table, .apply-table thead, .apply-table tbody, .apply-table tr, .apply-table th, .apply-table td, .apply-table colgroup { display: block; }
  .apply-table { border: none; }
  .apply-table tbody>tr { display: grid; grid-template-columns: 1fr; gap: 8px; padding: 12px 14px; border: 1px solid #eee; border-radius: 8px; background: #fff; }
  .apply-table tbody>tr+tr { margin-top: 12px; }
  .apply-table th { background: transparent; border-bottom: 0; padding: 4px 0 0; font-size: 0.92rem; color: #111; }
  .apply-table td { border-bottom: 0; padding: 0 0 4px; }
  .apply-table th [class^="req"], .apply-table th .req { color: #e11d48; }
  .inp { max-width: 90%; height: 44px; }
  .inline { gap: 10px 12px; }
  .ck { margin-right: 0; }
  .etc-inp { width: 100%; max-width: 100%; }
  .actions { flex-direction: column; }
  .btn { width: 100%; min-width: 0; }
}

/* =========================================================
 * 태블릿 최적화 (721px ~ 1024px)
 * ======================================================= */
@media (min-width: 721px) and (max-width: 1024px) {
  .apply-table colgroup col:first-child { width: 180px !important; }
  .inp { max-width: 90%; }
}

/* =========================================================
 * 접근성/상태 보조 (선택)
 * ======================================================= */
.inp[disabled] { background: #f6f7f8; color: #6b7280; }
input[type="radio"], input[type="checkbox"] { inline-size: 16px; block-size: 16px; }
/* .file-name {  border: 0;  background: none;  padding: 0;  color: #006aff;  text-decoration: underline;  cursor: pointer;  word-break: break-all;  text-align: left; } */

.file-name {
  border: 0;
  background: none;
  padding: 0;
  color: #2563eb; /* 살짝 덜 튀는 파랑 */
  text-decoration: underline;
  cursor: pointer;
  word-break: break-all;
  text-align: left;
  
}

.file-name:hover {
  color: #1d4ed8;
}

.file-name:focus-visible {
  outline: 2px solid #9fb7c7;
  outline-offset: 2px;
  border-radius: 2px;
}
</style>